"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'botTest.target.avatar': 'Avatar Objetivo',
};
